// extracted by mini-css-extract-plugin
export default {"list":"BillingInfoTabs_list__tx1r8","item":"BillingInfoTabs_item__xDfw0","item_active":"BillingInfoTabs_item_active__ZrdGy"};